import { useQuery, UseQueryResult } from 'react-query';
import pDebounce from 'p-debounce';

import { getTokenWithType } from './useAuth';

import { tagMappings } from '../utils/urls';

import { TagMappings } from 'types/tagMapping';
import { ErrorModal } from 'types/modalTypes';

async function fetchTagMappings({ accountId }: TVariables): Promise<TResult> {
  const response = await fetch(tagMappings(accountId), {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

const debouncedFetch = pDebounce(fetchTagMappings, 500);

type TError = ErrorModal;

type TResult = {
  Data: Array<TagMappings>;
  IsSuccess: boolean;
  StatusCode: number;
};

type TVariables = {
  accountId: number;
};

function useGetTagMappings(accountId: number): UseQueryResult<TResult, TError> {
  return useQuery(
    'get_tag_mappings',
    async () => {
      const fetchResponse = await debouncedFetch({
        accountId,
      });
      return fetchResponse;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetTagMappings };
